import { useCadastrarEditarProdutoContext } from "../../../../contexts/CadastrarEditarProdutoContext";
import { ComplementosContainer } from "../../../../containers/ComplementosContainer";
import { ConfiguracaoPreparadoContainer } from "../../../../containers/ConfiguracaoPreparadoContainer";
import { ControleEstoqueContainer } from "../../../../containers/ControleEstoqueContainer";
import { ConfiguracaoKDSContainer } from "../../../../containers/ConfiguracaoKDSContainer";
import { ConfiguracaoImpostoContainer } from "../../../../containers/ConfiguracaoImpostoContainer";

interface CadastrarPreparadoContainerProps { }

export const CadastrarPreparadoContainer = ({ }: CadastrarPreparadoContainerProps) => {
    const { step } = useCadastrarEditarProdutoContext();

    return (
        <>
            {step == 0 && (
                <ConfiguracaoPreparadoContainer />
            )}
            {step == 1 && (
                <ControleEstoqueContainer />
            )}
            {step == 2 && (
                <ConfiguracaoKDSContainer />
            )}
            {step == 3 && (
                <ComplementosContainer />
            )}
            {step == 4 && (
                <ConfiguracaoImpostoContainer />
            )}
        </>
    );
}
